if (!customElements.get('hotspot-section')) {
  class HotspotSection extends HTMLElement {
    connectedCallback() {
      this.section = this.querySelector('.advanced-hotspot-section');
      if (!this.section) return;

      this.mobileDisplay = this.section.getAttribute('data-mobile-display');
      this.points = Array.from(this.section.querySelectorAll('.advanced-hotspot-point'));
      this.sideContents = Array.from(this.section.querySelectorAll('.advanced-hotspot-side-content'));
      this.popups = Array.from(this.section.querySelectorAll('.advanced-hotspot-popup'));

      this.points.forEach((point) => {
        point.addEventListener('click', (event) => {
          event.stopPropagation();
          const hotspotId = point.getAttribute('data-hotspot-id');
          const isDesktop = window.innerWidth >= 769;
          if (!isDesktop && this.mobileDisplay === 'popup') {
            this.openPopup(hotspotId);
          } else {
            this.switchHotspot(hotspotId);
          }
        });
      });

      this.section.querySelectorAll('.advanced-hotspot-popup-close').forEach((btn) => {
        btn.addEventListener('click', () => {
          const popup = btn.closest('.advanced-hotspot-popup');
          if (popup) this.closePopup(popup);
        });
      });

      this.popups.forEach((popup) => {
        popup.addEventListener('click', (event) => {
          if (event.target === popup) this.closePopup(popup);
        });
      });

      this.onKeydown = this.onKeydown.bind(this);
      document.addEventListener('keydown', this.onKeydown);

      if (this.points.length > 0 && !this.section.querySelector('.advanced-hotspot-point.active')) {
        this.switchHotspot(this.points[0].getAttribute('data-hotspot-id'));
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const activePopup = this.section.querySelector('.advanced-hotspot-popup.active');
      if (activePopup) this.closePopup(activePopup);
    }

    switchHotspot(hotspotId) {
      this.points.forEach((point) => {
        const isActive = point.getAttribute('data-hotspot-id') === hotspotId;
        point.classList.toggle('active', isActive);
        point.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
      this.sideContents.forEach((content) => {
        content.classList.toggle('active-content', content.getAttribute('data-hotspot-id') === hotspotId);
      });
    }

    openPopup(hotspotId) {
      const popup = this.section.querySelector('.advanced-hotspot-popup[data-popup-id="' + hotspotId + '"]');
      if (!popup) {
        this.switchHotspot(hotspotId);
        return;
      }
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';
      const closeButton = popup.querySelector('.advanced-hotspot-popup-close');
      if (closeButton) closeButton.focus();
    }

    closePopup(popup) {
      const popupId = popup.getAttribute('data-popup-id');
      popup.classList.remove('active');
      document.body.style.overflow = '';
      const trigger = this.section.querySelector('.advanced-hotspot-point[data-hotspot-id="' + popupId + '"]');
      if (trigger) trigger.focus();
    }
  }

  customElements.define('hotspot-section', HotspotSection);
}
